<script lang="ts">
  import {onDestroy, SvelteComponent} from 'svelte';
  import editorStore from '../editor.store';
  let components: Array<typeof SvelteComponent> = [];
  const unsubscribe = editorStore.subscribe(store => {
    components = store.stylebarComponents;
  });
  onDestroy(() => unsubscribe);
</script>

<div class="flex w-full p-4">
  {#each components as comp}
    <svelte:component this={comp} />
  {/each}
</div>
